/* global window */

import log from 'loglevel';
import store from 'store/dist/store.modern';
import uuidv4 from 'uuid/v4';

const liidKey = 'liid';

/**
 * Create, store and return a local installation ID.
 * If the liid is alredy set, return the existing value.
 * Local storage is used by default, with a fallback to cookies.
 * @returns {String}
 */
function liid() {
  if (!store.enabled) {
    log.error('Storage not available.');
    return uuidv4();
  }

  let liidValue = store.get(liidKey);

  if (typeof liidValue === 'undefined') {
    liidValue = uuidv4();
    store.set(liidKey, liidValue);
    log.debug('New liid created.');
  }

  return liidValue;
}

export default liid;

window.Metaphor = window.Metaphor || {};
window.Metaphor.getLiid = liid;



// WEBPACK FOOTER //
// ./src/liid.js